module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ed-input-item', {
    attrs: {
      "label": _vm.label,
      "info": _vm.info,
      "name": _vm.name,
      "required": _vm.required
    }
  }, [(_vm.isRadio) ? [_c('div', {
    staticClass: "el-input"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "form-check col-12 text-left pl-0"
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": _vm.name,
        "id": _vm.name + '_' + item.id,
        "disabled": _vm.disabled || _vm.disabledItem(item)
      },
      domProps: {
        "checked": _vm.value == item.id ? 'checked' : '',
        "value": _vm.value
      },
      on: {
        "change": function($event) {
          return _vm.setEvent('input', this.isObject ? item : item.id)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "form-check-label",
      attrs: {
        "for": _vm.name + '_' + item.id
      }
    }, [_vm._v("\n          " + _vm._s(item.descricao) + "\n        ")]), _vm._v(" "), (!!_vm.$slots[_vm.name + '_' + item.id]) ? _c('div', {
      staticClass: "mb-2",
      staticStyle: {
        "background": "#ffdbdb"
      }
    }, [_vm._t(_vm.name + '_' + item.id)], 2) : _vm._e()])
  }), 0)] : [_c('el-select', {
    attrs: {
      "value": _vm.value,
      "clearable": _vm.clearable,
      "loading": _vm.loading,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "multiple": _vm.multiple,
      "value-key": _vm.valueKey,
      "collapse-tags": "",
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.setEvent('input', $event)
      }
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.descricao,
        "value": this.isObject ? item : item[_vm.valueKey]
      }
    })
  }), 1)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e37e0ff"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/EdInputSelectTipo.vue
// module id = 1424
// module chunks = 45